import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalTweetsConfig = {
    name: 'kpi.twitter.total_tweets',
    id: 'tweets',
    tooltip: 'kpi.twitter.tooltip_total_tweets',
    icon: {
        name: 'twitter',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_25,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
